export default __webpack_public_path__ + "static/media/calendar_date_icon.ed126f36.svg";